import React, { useMemo, useState } from 'react';
import {
  FilterBottomsheetComponents,
  FilterBottomsheetProps,
  FilterButtonProps,
} from './FilterBottomSheet.types';
import { FilterButton } from './FilterBottomSheet.styles';
import { AllieFilterOutlineIcon } from '../../../styling/icons';
import { BottomSheetComponent } from './components/BottomSheetComponent';
import { AllieText } from '../../../components';

export const useFilterBottomsheet = (): FilterBottomsheetComponents => {
  const [isOpen, setIsOpen] = useState(false);

  const FilterButtonComponent: React.FC<FilterButtonProps> = ({ text, allieTextProps }) => (
    <FilterButton allieType="subtle" allieSize="xs" onClick={() => setIsOpen(true)}>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--allie-spacing-xs)' }}>
        <AllieFilterOutlineIcon />
        {text && <AllieText {...allieTextProps}>{text}</AllieText>}
      </div>
    </FilterButton>
  );

  const BottomSheet = useMemo(
    () =>
      ({
        filters,
        onApplyFilters,
        preselectedFilters = {},
        onClose,
        labels,
        onFilterChange,
      }: FilterBottomsheetProps) => (
        <BottomSheetComponent
          isOpen={isOpen}
          setIsOpen={setIsOpen}
          filters={filters}
          onApplyFilters={onApplyFilters}
          onClose={onClose}
          labels={labels}
          preselectedFilters={preselectedFilters}
          onFilterChange={onFilterChange}
        />
      ),
    [isOpen, setIsOpen]
  );

  return { FilterButton: FilterButtonComponent, BottomSheet };
};
